<template>
  <div class="sports_rankx">
    <div class="head">
      <div class="v-title">—— {{ title }}数据榜 ——</div>
    </div>
    <div class="rhr"></div>
    <div class="rank-my">
      <div class="t-i">
        <div class="t-ti">
          我的排行榜
        </div>

      </div>
      <Row type="flex" class="myinfo" justify="space-between" align="center">
        <Col span="5">
          <div class="myavatar">
            <VanImage :src="myinfo.avatar" />
          </div>
          <!--          <div class="myrank">-->
          <!--            <template v-if="+myinfo.rank > 0">排名 {{ myinfo.rank }}</template>-->
          <!--            <template v-else>暂无排名</template>-->
          <!--          </div>-->
        </Col>
        <Col span="10">
<!--          <div-->
<!--              style="padding-bottom: .2rem;font-weight: bold;font-size:.35rem;"-->
<!--          >{{ myinfo.name ? myinfo.name : myinfo.nickname }}</div>-->
          <div>
            <div>{{ myinfo.register_type && '组别:' + myinfo.register_type }}</div>
            <div v-if="+myinfo.rank > 0">当前排名：第{{ myinfo.rank }}位</div>
            <div v-else>尚未参加</div>
          </div>
        </Col>
        <Col>
          <span v-if="+myinfo.state === 1" style="font-size: .24rem">
            <template
                v-if="physical_item_id"
            >{{myinfo.score}} 分/{{ myinfo.raw_score*1 }} {{type|SportsItemtype}}</template>
            <template v-else>最佳成绩：{{ myinfo.score*1 }} {{type|SportsItemtype}}</template>
          </span>
          <span v-else-if="+myinfo.state === 3">
              审核不通过
          </span>
          <span v-else-if="!myinfo.state"></span>
          <span v-else>待审核</span>
        </Col>
      </Row>
    </div>
    <div class="rank-body">
      <div class="t-i">
        <div class="t-ti">
          前十榜单
        </div>

      </div>
      <span class="noti">*本榜单数据每日实时更新，最终截止时间为当日的23:59:59</span>
      <div class="r-header">
        <div>排名</div>
        <div>用户名</div>
        <div>项目打分</div>
      </div>
      <List
          style="color:#FFF;"
          v-model="loading"
          :finished="finished"
          @load="getRankList"
      >
        <div class="rank-list">
          <div class="filter">
            <div
                v-for="(item, index) in filter"
                :key="index"
                class="item"
                :class="{ active: item.active == 1 }"
                @click="onChange(item)"
            >{{ item.value }}</div>
          </div>
          <CellGroup :style="{'border-radius': borderRadius,background: '#FDF5F6',height: rankList.length>5&&show?'6rem':'auto'}" v-if="rankList.length" :border="false">
            <Cell v-for="item in rankList" :key="item.id" center v-if="item.rank<11"  class="rank" style="background: #FDF5F6;" title-style="color:#D22E2C;">
              <div slot="title">{{item.nickname}}</div>
              <div slot="icon" class="rank_icon">
                <template v-if="item.rank <= 3">
                  <img src="@/assets/img/rank/first.png" :alt="item.rank" v-if="item.rank == 1" />
                  <img src="@/assets/img/rank/second.png" :alt="item.rank" v-if="item.rank == 2" />
                  <img src="@/assets/img/rank/third.png" :alt="item.rank" v-if="item.rank == 3" />
                </template>

                <span v-else>{{ item.rank }}</span>
                <VanImage :src="item.avatarurl" />
              </div>


              <template><span v-if="+item.state !== 3">{{ item.score*1 }} {{type|SportsItemtype}}</span><span class="desc" v-else>不符合规定<br />审核不通过</span></template>
            </Cell>
          </CellGroup>
          <div v-if="rankList.length>5" :class="[ 'op', show?'':'tran' ]" @click="handleshow"><img src="https://oss.mcloud.moveclub.cn/mpms/20210722/1626948261-60f942a56643a.png" alt=""></div>
          <Empty
              style="background: #fff;min-height: 6rem"
              :style="`border-radius: ${borderRadius}`"
              v-if="rankList.length===0"
              description="暂无数据"
          />
        </div>
      </List>
    </div>
    <div class="rank-body">
      <div class="t-i">
        <div class="t-ti">
          我的挑战记录
        </div>

      </div>
      <div class="rank-list" style="padding-bottom: .6rem;">
        <CellGroup :style="{'border-radius': borderRadius,background: '#FDF5F6'}" v-if="myList.length" :border="false">
          <Cell v-for="(item,index) in myList" :key="item.id" center class="rank bb" style="background: #FDF5F6;">
            <div slot="title">{{item.create_time|fromunixtime}}</div>
            <div slot="icon" class="rank_icon">

              <span>{{ index+1 }}</span>
            </div>

            <template><span v-if="+item.state !== 3">{{ item.score*1 }} {{type|SportsItemtype}}</span><span class="desc" v-else>不符合规定<br />审核不通过</span></template>
          </Cell>
        </CellGroup>
        <Empty
            style="background: #fff;min-height: 6rem;"
            :style="`border-radius: ${borderRadius}`"
            v-if="myList.length===0"
            description="暂无数据"
        />
      </div>
    </div>
  </div>
</template>

<style lang="less" scoped>
@import "./index.less";

.filter {
  width: 6.9rem;
  margin: 0 auto;
  display: flex;
  align-items: center;

  .item {
    font-size: 0.3rem;
    padding: 0.12rem 0;
    width: 2rem;
    display: flex;
    justify-content: center;
    border-radius: 0.2rem 0.2rem 0 0;

    &.active {
      background: #fff;
      color: #333;
    }
  }
}
</style>

<script>
import { Empty, Panel, Cell, CellGroup, Image, List, Row, Col } from "vant";

export default {
  computed: {
    buttonColor() {
      let detail = this.detail;
      if (!detail) return "#ccc";
      return `${detail.tabstyle[0]["color"]}`;
    },
    borderRadius() {
      if (this.filter) {
        let i = this.filter.findIndex((row) => {
          return row.active == 1;
        });
        if (i == 0) {
          return "0 .2rem .2rem .2rem";
        } else {
          return ".2rem";
        }
      }
    },
  },
  components: {
    Empty,
    Panel,
    Cell,
    CellGroup,
    List,
    VanImage: Image,
    Row,
    Col,
  },
  props: ["item_sub_id", "sports_id", "item_id"],
  data() {
    return {
      rankList: [],
      loading: false,
      finished: false,
      detail: "",
      page: 1,
      systime: "",
      myinfo: "",
      register_type: "",
      filter: [],
      type: "",
      physical_item_id: 0,
      title: "",
      show: true,
      myList: []
    };
  },
  methods: {
    onChange(row) {
      if (this.loading) return;
      this.filter.forEach((item) => {
        item.active = 0;
      });
      row.active = 1;
      this.register_type = row.value;
      this.rankList = [];
      this.page = 1;
      this.getRankList();
    },
    handleshow() {
      this.show = !this.show
    },
    getRankList: function () {
      //如果为空or 0 按照 item_id  rank
      if (!+this.item_sub_id) {
        this.$api.sports
          .getSportsItemRank({ id: this.item_id, page: this.page })
          .then((res) => {
            let { page, list } = res.data;
            this.systime = res.sys_time;
            this.loading = false;
            list.forEach((item, index) => {
              item = Object.assign(item, item.userInfo);
              item.score = +item.total_score ? item.total_score : 0;
              if (index > 0 && +item.score === +list[index - 1]["score"]) {
                item.rank = list[index - 1]["rank"];
              } else if (index === 0) {
                if (this.rankList.length) {
                  let last = this.rankList[this.rankList.length - 1];
                  if (+item.score === +last.score) {
                    item.rank = last.rank;
                  } else {
                    item.rank = last["rank"] * 1 + 1;
                  }
                } else {
                  item.rank = 1;
                }
              } else {
                item.rank = list[index - 1]["rank"] * 1 + 1;
              }
            });
            if (+page.currentPage === 1) {
              this.rankList = list;
            } else {
              this.rankList = this.rankList.concat(list);
            }
            if (+page.currentPage >= page.pageCount) {
              this.finished = true;
            } else {
              this.page++;
            }
          });
      } else {
        this.$api.sports
          .compareRank2(
            Object.assign({
              cpgid: this.item_sub_id,
              page: this.page,
              sort: 2,
              register_type: this.register_type,
            })
          )
          .then((res) => {
            if (+res.status !== 200) {
              this.finished = true;
              return;
            }
            this.systime = res.sys_time;
            this.loading = false;
            let {
              list,
              page,
              pages,
              myinfo,
              title,
              type,
              physical_item_id,
            } = res.data;
            this.myinfo = myinfo;
            this.type = type;
            this.title = title
            this.physical_item_id = physical_item_id;
            let t = null
            list.forEach((item, index) => {
              if(t == null){
                t =  item;
                t.rank = index+1;
              }else{
                var n = item;
                if(+n.score == +t.score){
                  n.rank = t.rank;
                }else{
                  n.rank = index+1;
                }
                t = n;
              }
            });
            this.filter = res.data.filter;
            this.rankList = list;
            this.finished = true;
            // if (page == 1) {
            //   this.rankList = list;
            // } else {
            //   this.rankList = this.rankList.concat(list);
            // }
            //
            // if (page >= pages) {
            //   this.finished = true;
            // } else {
            //   this.page++;
            // }
          });
      }
    },
    init: function () {
      this.$toast.loading({
        duration: 0,
      });
      let params = { cpgid: this.item_sub_id };
      this.$api.sports.sportsMain(this.sports_id).then((res) => {
        let { bgstyle, id, tabstyle, introstyle, title } = res.data;
        try {
          bgstyle = JSON.parse(bgstyle);
          tabstyle = JSON.parse(tabstyle);
          introstyle = JSON.parse(introstyle);
        } catch (e) {
          console.error(e);
        }
        this.detail = { id, bgstyle, tabstyle, introstyle, title };
        this.$toast.clear();
      });
      this.$api.sports.myRanks({acid: this.item_sub_id}).then((res) => {
        this.myList = res.data.list
      })
      if (!+this.item_sub_id) {
        this.$api.sports
          .getMySportsItemRank({ id: this.item_id })
          .then((res) => {
            this.myinfo = res.data;
          });
      }
    },
  },
  mounted() {
    this.init();
    // this.getRankList();
  },
};
</script>
